import { StoreBaseHandler } from "../../../../infrastructure/base-handlers";
import { setCustomFilterValue } from "./actions";
import { SetCustomFilterValue } from "./request";

export class SetCustomFilterValueHandler extends StoreBaseHandler {
  async handle(request: SetCustomFilterValue) {
    try {
      this.store.dispatch(setCustomFilterValue(request.payload));
    } catch (e) {
      console.error(e.message);
    }
  }
}
